// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// A stable header footprint: only its background changes while scrolling.
(() => {
  if (!document.body.classList.contains('sp-home') && !document.body.classList.contains('sp-collection-page')) return;
  const header = document.querySelector('.section-header');
  if (!header) return;
  const update = () => {
    const overlay = document.body.classList.contains('sp-home') || document.querySelector('[data-sp-transparent-header]');
    document.body.classList.toggle('sp-header-overlay', Boolean(overlay));
    header.classList.toggle('sp-header-scrolled', Boolean(overlay) && window.scrollY > 48);
  };
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', update);
})();

// Judge.me's pagination normally scrolls twice and hides the complete review body.
// Opt out through the widget's own flag, then position it once below the header.
document.addEventListener('click', event => {
  const page = event.target.closest('.jdgm-paginate__page');
  if (!page || page.classList.contains('jdgm-curt') || page.getAttribute('aria-disabled') === 'true') return;
  const widget = page.closest('.jdgm-review-widget');
  const body = widget?.querySelector('.jdgm-rev-widg__body');
  if (!body) return;
  widget.setAttribute('data-not-scroll-to', 'true');
  body.scrollIntoView({ block: 'start', behavior: 'instant' });
}, true);

// Native touch scrolling with optional desktop arrows.
if (!customElements.get('sp-card-gallery')) {
  customElements.define('sp-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sp-card-gallery__track');
      if (!this.track) return;
      this.events?.abort();
      this.events = new AbortController();
      this.marks = [...this.querySelectorAll('.sp-card-gallery__position span')];
      this.update = () => {
        const page = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        if (!this.scrolling) this.page = page;
        this.marks.forEach((mark, index) => mark.classList.toggle('is-active', index === page));
      };
      this.track.addEventListener('scroll', this.update, { passive: true, signal: this.events.signal });
      this.track.addEventListener('scrollend', () => { this.scrolling = false; this.update(); }, { signal: this.events.signal });
      this.track.addEventListener('pointerdown', () => { this.scrolling = false; }, { signal: this.events.signal });
      this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.page = ((this.page || 0) + Number(button.dataset.galleryStep) + this.marks.length) % this.marks.length;
        this.scrolling = true;
        this.track.scrollTo({ left: this.page * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.events.signal }));
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
